var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"color":_vm.color ? _vm.color : 'primary'}},[_c('v-toolbar-title',{staticClass:"white--text capitalize"},[_vm._t("default")],2),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }